import InfoIcon from '@mui/icons-material/Info';
import { Box, Container, Grid, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import 'survey-core/survey.i18n.js';
// import { Serializer, ItemValue, Action, Base, ComputedUpdater } from 'survey-core';
import { Serializer, Action, Base, ComputedUpdater } from 'survey-core';
import 'survey-creator-core/survey-creator-core.i18n.js';
import { settings, localization, editorLocalization } from 'survey-creator-core';
import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';
import './index.css';
import { ReactElementFactory } from 'survey-react-ui';
import { ICandidateStageStatusPipelineSetting } from 'wisestep-api';
import {
  WsButton,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsSelect,
  WsSelectObj,
  WsColors,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../context/WorkspaceContext';
import { evaluationAmplitudeEvents } from '../../features/conversationWidget/utils/rtrHelper';
import StageStatusContextProvider, {
  useStageStatusContext,
} from '../../features/submissions/context/StageStatusContext';
import useCandidateStatusesByStage from '../../hooks/useCandidateStatusesByStage';
import { getCandidateStagesInWsSelectObj } from '../../utils/CandidateStageStatusHelper';
import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';

// import {
//   oneRateValue,
//   twoRateValues,
//   threeRateValues,
//   fourRateValues,
//   fiveRateValues,
//   sixRateValues,
//   sevenRateValues,
//   eightRateValues,
//   nineRateValues,
//   tenRateValues,
// } from './CustomeRating';

export let stageStatusData = {};
export let isAssociateStatusAdded = false;

interface SurveyCreatorRenderComponentProps {
  associateJsonObject?: any;
  modeType: number;
  jsonObject: any;
  tamplateId: string;
  backToTemplate: () => void;
  addGetDataBack: (body: any) => void;
  updateGetDataBack: (body: any) => void;
}

interface AssociateStatusProps {
  associateStatusData?: any;
}
export const AssosciateStatus: React.FC<AssociateStatusProps> = (props) => {
  useEffect(() => {
    stageStatusData = {};
    isAssociateStatusAdded = false;
  }, [props, props.associateStatusData]);

  return (
    <>
      <StageStatusContextProvider>
        <AssociateStatusContext associateStatusData={props.associateStatusData} />
      </StageStatusContextProvider>
    </>
  );
};

const AssociateStatusContext: React.FC<AssociateStatusProps> = (props) => {
  const methods = useForm();
  const { watch } = methods;
  const stageStatus = useStageStatusContext();
  const [candidateStageStatusSettings, setCandidateStageStatusSettings] =
    useState<ICandidateStageStatusPipelineSetting>();
  const [stages, setStages] = useState<WsSelectObj[]>([]);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const workspace = useWorkspaceContext();

  const useGetStatusWithStage = (selectedStage: string) => {
    const selectedStageValue = watch(selectedStage);
    const statuses = useCandidateStatusesByStage(
      candidateStageStatusSettings?.stageStatusPipeline ?? '',
      selectedStageValue
    );

    const statusesObjects: WsSelectObj[] = statuses?.map((status) => ({
      label: `${status.value}`,
      value: `${status.value}`,
    }));
    return statusesObjects;
  };

  const onSubmit = (data) => {
    const formData = {
      questionDescription: data.questionDescription,
    };
    if (!formData.questionDescription.trim()) {
      setNotification(warning('Oops , question description is missing !!'));
      return;
    }

    stageStatusData['questionDescription'] = formData.questionDescription as string;
    for (let i = 1; i <= 4; i++) {
      const optionKey = `option${i}`;
      const stageKey = `stage${i}`;
      const statusKey = `status${i}`;

      formData[optionKey] = data[optionKey];
      formData[stageKey] = data[stageKey];
      formData[statusKey] = data[statusKey];

      stageStatusData[optionKey] = formData[optionKey] as string;
      stageStatusData[stageKey] = formData[stageKey] as string;
      stageStatusData[statusKey] = formData[statusKey] as string;
    }

    if (stageStatusData) {
      isAssociateStatusAdded = true;
      setNotification(success('Associate Template Added/Updated'));
    }
  };

  const onSubmitDefaultStageStatus = (data) => {
    stageStatusData['defaultStage'] = '';
    stageStatusData['defaultStatus'] = '';

    if (!data.defaultStage.trim()) {
      setNotification(warning('Oops , default stage is missing !!'));
      return;
    }
    if (!data.defaultStatus.trim()) {
      setNotification(warning('Oops , default status is missing !!'));
      return;
    }
    if (data['defaultStage']) {
      stageStatusData['defaultStage'] = data['defaultStage'];
    }
    if (data['defaultStatus']) {
      stageStatusData['defaultStatus'] = data['defaultStatus'];
    }
    if (data.defaultStage.trim() && data.defaultStatus.trim()) {
      isAssociateStatusAdded = true;
      setNotification(success('Default status is Added'));
    }
    evaluationAmplitudeEvents('eval_stage_status', 'Associating a stage status ', workspace);
  };

  useEffect(() => {
    stageStatusData = {};
    setCandidateStageStatusSettings(stageStatus);
    setStages(getCandidateStagesInWsSelectObj(stageStatus));
    isAssociateStatusAdded = false;
  }, [props.associateStatusData, stageStatus]);

  return (
    <>
      <Grid container xs={12}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmitDefaultStageStatus)}>
            <Container>
              <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item xs={12} mt={3} mb={2}>
                  <Tooltip title="Selecting this option will update the stage status when evaluation is shared">
                    <Box mt={1} sx={{ display: 'flex', alignItems: 'center' }}>
                      <WsTypography
                        variant={WsTypoVariants.SUB_TITLE}
                        bold
                        color={WsTypoColors.PRIMARY}
                      >
                        <span>{props.associateStatusData?.modeType === 2 ? 'View ' : 'Add '}</span>
                        <span>Associate Stage Status while sharing evaluation</span>
                      </WsTypography>
                      <InfoIcon
                        sx={{
                          position: 'relative',
                          marginLeft: '4px',
                          zIndex: 1,
                          color: WsColors.TertiaryShades300,
                        }}
                        fontSize="small"
                      />
                    </Box>
                  </Tooltip>
                </Grid>
                <Grid container spacing={2} xs={12}>
                  <Grid item xs={4}>
                    <Controller
                      name="defaultStage"
                      control={methods.control}
                      defaultValue={
                        props.associateStatusData?.associateJsonObject?.defaultStage || ''
                      }
                      render={({ field }) => (
                        <WsSelect {...field} selectArray={stages} placeholder="Stage" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Controller
                      name="defaultStatus"
                      control={methods.control}
                      defaultValue={
                        props.associateStatusData?.associateJsonObject?.defaultStatus || ''
                      }
                      render={({ field }) => (
                        <WsSelect
                          {...field}
                          // eslint-disable-next-line react-hooks/rules-of-hooks
                          selectArray={useGetStatusWithStage('defaultStage')}
                          placeholder="Status"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {props.associateStatusData?.modeType !== 2 && (
                      <>
                        <WsButton variant="outlined" size="medium" type="submit">
                          {props.associateStatusData?.modeType === 1 ? 'Update' : 'Add'}
                        </WsButton>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </form>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Container>
              <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item xs={12} mt={3} mb={2}>
                  <Tooltip title="Selecting this option will update the stage status when evaluation response is shared by evaluator">
                    <Box mt={1} sx={{ display: 'flex', alignItems: 'center' }}>
                      <WsTypography
                        variant={WsTypoVariants.SUB_TITLE}
                        bold
                        color={WsTypoColors.PRIMARY}
                      >
                        <span>{props.associateStatusData?.modeType === 2 ? 'View ' : 'Add '}</span>
                        <span>Associate Status while responding evaluation</span>
                      </WsTypography>
                      <InfoIcon
                        sx={{
                          position: 'relative',
                          marginLeft: '4px',
                          zIndex: 1,
                          color: WsColors.TertiaryShades300,
                        }}
                        fontSize="small"
                      />
                    </Box>
                  </Tooltip>
                </Grid>

                {props.associateStatusData?.modeType === 2 ? (
                  <>
                    <Grid item xs={12} mb={3}>
                      <Controller
                        name="questionDescription"
                        control={methods.control}
                        defaultValue={
                          props.associateStatusData?.associateJsonObject?.questionDescription || ''
                        }
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            variant="outlined"
                            label="Question description"
                            placeholder="Question description"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {[1, 2, 3, 4].map((option) => (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Controller
                              name={`option${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `option${option}`
                                ] || 'NA'
                              }
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  variant="outlined"
                                  label={`Option${option}`}
                                  sx={{ width: '70%', marginLeft: '20px', marginBottom: '10px' }}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Controller
                              name={`stage${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `stage${option}`
                                ] || 'NA'
                              }
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  variant="outlined"
                                  label={`stage${option}`}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Controller
                              name={`status${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `status${option}`
                                ] || 'NA'
                              }
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  variant="outlined"
                                  label={`status${option}`}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </>
                    ))}
                  </>
                ) : (
                  <>
                    <Grid item xs={12} mb={3}>
                      <Controller
                        name="questionDescription"
                        control={methods.control}
                        defaultValue={
                          props.associateStatusData?.associateJsonObject?.questionDescription || ''
                        }
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            variant="outlined"
                            label="Question description"
                            placeholder="Question description"
                          />
                        )}
                      />
                    </Grid>
                    {[1, 2, 3, 4].map((option) => (
                      <>
                        <Grid container spacing={2} alignItems="center" justifyContent="center">
                          <Grid item xs={4}>
                            <Controller
                              name={`option${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `option${option}`
                                ] || ''
                              }
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  variant="outlined"
                                  label={`Option${option}`}
                                  placeholder={`Option - ${option}`}
                                  sx={{ width: '70%', marginLeft: '20px', marginBottom: '10px' }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Controller
                              name={`stage${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `stage${option}`
                                ] || ''
                              }
                              render={({ field }) => (
                                <WsSelect
                                  {...field}
                                  selectArray={stages}
                                  placeholder={`Stage - ${option}`}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Controller
                              name={`status${option}`}
                              control={methods.control}
                              defaultValue={
                                props.associateStatusData?.associateJsonObject?.[
                                  `status${option}`
                                ] || ''
                              }
                              render={({ field }) => (
                                <WsSelect
                                  {...field}
                                  // eslint-disable-next-line react-hooks/rules-of-hooks
                                  selectArray={useGetStatusWithStage(`stage${option}`)}
                                  placeholder={`Status - ${option}`}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </>
                    ))}
                    <Grid item xs={12}>
                      {props.associateStatusData?.modeType !== 2 && (
                        <>
                          <WsButton variant="outlined" size="medium" type="submit">
                            {props.associateStatusData?.modeType === 1 ? 'Update' : 'Add'}
                          </WsButton>
                        </>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Container>
          </form>
        </FormProvider>
      </Grid>
    </>
  );
};

const SurveyCreatorRenderComponent: React.FC<SurveyCreatorRenderComponentProps> = (props) => {
  ReactElementFactory.Instance.registerElement('svc-tab-template', () => {
    return React.createElement(AssosciateStatus, {
      associateStatusData: props,
    });
  });

  let svJsonObject: any = null;
  let sJsonObject = props.jsonObject;
  let sModeType = props.modeType;
  let sTemplateId = props.tamplateId;
  let isShowDesginer = true;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const workspace = useWorkspaceContext();

  settings.propertyGrid.maximumRateValues = 10;

  settings.toolbox.defaultJSON['rating'] = {
    displayMode: 'buttons',
    rateValues: [
      { value: 1, text: 'Extremely poor' },
      { value: 2, text: 'Poor' },
      { value: 3, text: 'Good' },
      { value: 4, text: 'Very good' },
      { value: 5, text: 'Excellent' },
    ],
  };

  Serializer.getProperty('rating', 'rateType').defaultValue = 'none';
  Serializer.getProperty('rating', 'rateType').visible = true;
  Serializer.getProperty('rating', 'rateCount').visible = false;
  Serializer.getProperty('rating', 'autoGenerate').defaultValue = true;
  Serializer.getProperty('rating', 'autoGenerate').visible = false;

  const options = {
    showLogicTab: false,
    showPanelBaseTab: false,
    showJSONEditorTab: false,
    showDesignerTab: isShowDesginer,
    toolboxLocation: 'none',
    questionTypes: ['boolean', 'text', 'multipletext', 'rating', 'tagbox', 'dropdown'],
  };

  isShowDesginer = sModeType === 2 ? false : true;

  const creator = new SurveyCreator(options);
  if (sModeType === 1 || sModeType == 2) {
    creator.JSON = sJsonObject;
  }
  creator.pageEditMode = 'bypage';
  creator.toolbox.forceCompact = true;
  creator.showSidebar = false;
  const translation = localization.getLocale();
  const rateTypeProp = Serializer.getProperty('rating', 'rateType');
  rateTypeProp.setChoices(['labels', 'stars']);

  translation.pv.rateType.labels = 'Semantic';

  creator.onDefineElementMenuItems.add((_, options) => {
    const question = options.obj;
    if (question.getType() === 'rating') {
      const indexToRemove = options.items.findIndex((item) => item.id === 'settings');
      if (indexToRemove !== -1) {
        options.items.splice(indexToRemove, 1);
      }
    }
  });

  const expandSettingsAction = creator.toolbar.actions.find(
    (action) => action.id === 'svd-grid-expand'
  );
  if (expandSettingsAction) {
    const index = creator.toolbar.actions.indexOf(expandSettingsAction);
    creator.toolbar.actions.splice(index, 1);
  }

  const settingsAction = creator.toolbar.actions.find((action) => action.id === 'svd-settings');
  if (settingsAction) {
    const index = creator.toolbar.actions.indexOf(settingsAction);
    creator.toolbar.actions.splice(index, 1);
  }
  creator.allowEditSurveyTitle = true;
  creator.onModified.add((sender) => {
    svJsonObject = sender.text;
  });

  // creator.onSurveyPropertyValueChanged.add((sender, options) => {
  //   if (
  //     options.propertyName === 'rateValues' &&
  //     options.oldValue.length !== options.newValue.length
  //   ) {
  //     const currentRateValueNumber = options.obj.rateValues.length;
  //     let newRateValues: { value: number; text: string }[] = [];
  //     switch (currentRateValueNumber) {
  //       case 1:
  //         newRateValues = oneRateValue;
  //         break;
  //       case 2:
  //         newRateValues = twoRateValues;
  //         break;
  //       case 3:
  //         newRateValues = threeRateValues;
  //         break;
  //       case 4:
  //         newRateValues = fourRateValues;
  //         break;
  //       case 5:
  //         newRateValues = fiveRateValues;
  //         break;
  //       case 6:
  //         newRateValues = sixRateValues;
  //         break;
  //       case 7:
  //         newRateValues = sevenRateValues;
  //         break;
  //       case 8:
  //         newRateValues = eightRateValues;
  //         break;
  //       case 9:
  //         newRateValues = nineRateValues;
  //         break;
  //       case 10:
  //         newRateValues = tenRateValues;
  //         break;
  //       default:
  //         newRateValues = [];
  //         break;
  //     }
  //     const newItemaValues = newRateValues.map(
  //       (newValue) => new ItemValue(newValue.value, newValue.text)
  //     );
  //     options.obj.rateValues = newItemaValues;
  //   }
  // });

  creator.onSetPropertyEditorOptions.add((sender, options) => {
    options.editorOptions.allowBatchEdit = false;
  });

  const translation1 = editorLocalization.getLocale('');
  translation1.ed.surveyPlaceHolder = `Click on the 'Add Question' below to start creating an evaluation template`;

  creator.onCollectionItemAllowOperations.add((sender, options) => {
    if (options.obj.getType() === 'rating') {
      options.allowEdit = false;
    }
  });
  const engLocale = localization.getLocale('en');
  engLocale.pe.surveyTitlePlaceholder = 'Template Title';

  const templatesPlugin = {
    activate: () => {},
    deactivate: () => {
      return true;
    },
    model: new Base(),
  };

  creator.addPluginTab(
    'templates',
    templatesPlugin,
    'Associate Stage Status',
    'svc-tab-template',
    2
  );

  creator.toolbar.actions.push(
    new Action({
      id: 'svd-back',
      title: 'Go to List',
      enabled: true,
      action: function () {
        sModeType = props.modeType;
        sJsonObject = null;
        stageStatusData = {};
        isAssociateStatusAdded = false;
        sTemplateId = '';
        props.backToTemplate();
      },
    })
  );

  if (isShowDesginer) {
    const tabs = ['designer', 'test', 'templates'];

    creator.toolbar.actions.push(
      new Action({
        id: 'svd-back',
        title: 'Back',
        visible: new ComputedUpdater(
          () => creator.activeTab === 'test' || creator.activeTab === 'templates'
        ),
        enabled: true,
        iconName: 'icon-arrowleft',
        action: () => {
          const currentIndex = tabs.indexOf(creator.activeTab);
          if (currentIndex > 0) {
            creator.activeTab = tabs[currentIndex - 1];
          } else {
            creator.activeTab = tabs[tabs.length - 1];
          }
        },
      })
    );
    creator.toolbarItems.push(
      new Action({
        id: 'next-button',
        iconName: 'icon-arrowright',
        title: 'Next',
        visible: new ComputedUpdater(
          () => creator.activeTab === 'designer' || creator.activeTab === 'test'
        ),
        enabled: true,
        action: () => {
          const currentIndex = tabs.indexOf(creator.activeTab);
          if (currentIndex < tabs.length - 1) {
            creator.activeTab = tabs[currentIndex + 1];
          } else {
            creator.activeTab = tabs[0];
          }
        },
      })
    );
    creator.toolbar.actions.push(
      new Action({
        id: 'svd-save',
        title: 'Save Template',
        visible: new ComputedUpdater(() => creator.activeTab === 'templates'),
        enabled: true,
        action: function () {
          let body = {
            description: null,
            template: null,
            associateStageStatusData: stageStatusData,
            templateName: null,
            id: '',
          };
          try {
            if (sModeType === 0) {
              body = {
                description: JSON.parse(svJsonObject).description,
                template: JSON.parse(svJsonObject),
                associateStageStatusData: stageStatusData,
                templateName: JSON.parse(svJsonObject).title,
                id: '',
              };
              props.addGetDataBack(body);
              evaluationAmplitudeEvents(
                'eval_template_created',
                'Creation of evaluation template',
                workspace
              );
            } else {
              const editTemplate = props.jsonObject;
              if (JSON.parse(svJsonObject) === null) {
                body = {
                  description: editTemplate.description,
                  template: editTemplate,
                  associateStageStatusData: stageStatusData,
                  templateName: editTemplate.title,
                  id: sTemplateId,
                };
              } else {
                body = {
                  description: JSON.parse(svJsonObject).description,
                  template: editTemplate,
                  associateStageStatusData: stageStatusData,
                  templateName: JSON.parse(svJsonObject).title,
                  id: sTemplateId,
                };
              }
              props.updateGetDataBack(body);
              evaluationAmplitudeEvents(
                'eval_template_edit',
                'Editing the evaluation template',
                workspace
              );
            }
          } catch (error) {
            console.log('error in survay ts file----->', error);
            setNotification(warning(`Oops, Required Field is missing`));
          }
        },
      })
    );
  }

  return <SurveyCreatorComponent creator={creator} />;
};
export default SurveyCreatorRenderComponent;
